import React from 'react';

function Panel({ children, dark }) {
  return (
    <div className={dark && 'dark'}>
      <div className="border p-4 text-gray-800 rounded-xl bg-white dark:bg-gray-800 dark:text-gray-200 dark:border-gray-700">
        {children}
      </div>
    </div>
  );
}

export default Panel;
